<template>
    <div class="card">
        <slot class="card-title" name="header">
            <slot name="header-action" />
        </slot>
        <slot class="card-body" name="body" />
    </div>
</template>

<script>
export default {
    name: "CardBox"
}
</script>


<style lang="scss" scoped>
.card {
    border: 0;
    padding: 20px 15px;
    border-radius: 10px;
    box-shadow: $cards-box-shadow;
    background-color: $dark-gray;

    h5 {
        text-transform: uppercase;
        font-weight: 600;
        font-size: 12px;
        color: white;
        line-height: 17px;
    }

    .card-body {
        padding: 0;
    }

    @media (max-width: $sm) {
        padding: 15px;
    }
}
</style>
